import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { ErrorDialogService } from '../error-dialog/error-dialog.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(
    private zone: NgZone,
    private errorService: ErrorDialogService
  ) { }

  handleError(error: any) {
    let message: string = '';
    if (error instanceof HttpErrorResponse) {
      message = this.getServerMessage(error);
    } else {
      // Client Error
      message = this.getClientMessage(error);
    } // IF-ELSE

    // this.zone.run(() => {
    //   setTimeout(() => this.errorService.openDialog(
    //     message,
    //     error.status
    //   ));
    // });
    console.error(message)

  } // FN HANDLE-ERROR

  getClientMessage(error: Error): string {
    if (!navigator.onLine) {
      return 'No Internet Connection';
    }

    return error.message ? error.message : error.toString();
  } // FN GET-CLIENT-MESSAGE

  getClientStack(error: Error): string {
    return error.stack!;
  } // FN GET-CLIENT-STACK

  getServerMessage(error: HttpErrorResponse): string {
    if (typeof error.error === 'string' && error.error.includes("AADB2C90077")) {
      return "Your session has expired. Please log in again.";
    }

    // Generic auth/session timeout
    if (error.status === 401 || error.status === 419 || error.status === 440) {
      return "Session expired. Please log in again.";
    }

    return error.message || "An unexpected error occurred.";
  } // FN GET-SERVER-MESSAGE

  getServerStack(error: HttpErrorResponse): string {
    // handle stack trace
    return 'stack';
  } // FN GET-SERVER-STACK

} // EXPORT